import axios from "axios";

export default async function fetchFloorJournals(
  legislatureOrdinal,
  committeeType,
  committeeTypeCode,
  committeeCode,
  chamber,
  meetingDateTime
) {
  try {
    const formattedDateTime = meetingDateTime.includes("T")
      ? meetingDateTime
      : `${meetingDateTime}T00:00:00`;

    const response = await axios.get(
      `${process.env.REACT_APP_LAWS_BACKEND_HOST}/docs/v1/documents/getCommitteeJournals`,
      {
        params: {
          legislatureOrdinal,
          committeeType,
          committeeTypeCode,
          committeeCode,
          chamber,
          meetingDateTime: formattedDateTime,
        },
      }
    );

    if (!response.data || response.data.length === 0) {
      return null;
    }

    // There are multiple duplicated Journals in the same folder, so we need to sort them by date and take the latest one uploaded by MT team.
    const sortedJournals = [...response.data].sort((a, b) => {
      const dateA =
        a.attributes?.find((attr) => attr.name === "SubmittedDate")
          ?.stringValue || "";
      const dateB =
        b.attributes?.find((attr) => attr.name === "SubmittedDate")
          ?.stringValue || "";
      return new Date(dateB) - new Date(dateA);
    });

    // Just return the latest journal with its ID, don't fetch URL yet
    return sortedJournals[0];

  } catch (error) {
    if (error.response?.status !== 404) {
      console.error("Error fetching committee journal:", error);
    }
    return null;
  }
}
